/* ==========================================================
   CPB SYMBOL PICKER
   Multiple product groups + different symbol sets
   Includes live character counter
   ========================================================== */

(function () {
  'use strict';

  /* ==========================================================
     PRODUCT GROUPS + SYMBOL SETS
     ========================================================== */

  const SYMBOL_GROUPS = {

    /* embossing sets */

    set1: {
      products: [
        'test-multi-model-embossed'
      ],

      symbols: [
        {
          character: '♥',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/heart-filled.webp?v=1786398018',
          label: 'Heart Filled'
        },

        {
          character: '♡',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/heart-outline.webp?v=1786398018',
          label: 'Heart Outline'
        },

        {
          character: '⚡',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/bolt.webp?v=1786398018',
          label: 'Lightning'
        },

        {
          character: '✈️',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/plane.webp?v=1786398018',
          label: 'Fly'
        },

        {
          character: '⭐',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/star.webp?v=1786398019',
          label: 'Star'
        }
      ]
    },

    /* printing / shadow sets */   

    set2: {
      products: [
        'personalised-black-saffiano-leather-card-holder-shadow-text',
        'personalised-ivory-saffiano-leather-card-holder-shadow-text',
        'personalised-pale-pink-saffiano-leather-card-holder-shadow-text',
        'personalised-nude-saffiano-leather-card-holder-shadow-text',
        'personalised-saffiano-leather-iphone-case-stripes-black',
        'personalised-saffiano-leather-iphone-case-shadow-black',
        'personalised-black-saffiano-leather-lanyard-id-holder-shadow-text',
        'personalised-clear-iphone-case-stripes',
        'personalised-clear-iphone-case-shadow-font',
        'personalised-mirror-iphone-case-stripes',
        'personalised-mirror-iphone-case-shadow-font',
        'personalised-saffiano-leather-iphone-case-bold-initials-black',
        'personalised-clear-iphone-case-bold-initials',
        'personalised-mirror-iphone-case-bold-initials',
         'black-saffiano-leather-magsafe-wallet-shadow-font',
      ],

      symbols: [
        {
           character: '\uE000',
           image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/love2.png?v=1786571690',
           label: 'Double Heart U+E000'
        },

        {
           character: '\uE001',
          image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/heart-filled.webp?v=1786398018',
          label: 'Heart U+2764'
        },

        {
           character: '\uE002',
           image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/heart-filled-small.webp?v=1786461495',
           label: 'Small Heart U+2665'
        },

        {
           character: '\uE003',
           image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/star.webp?v=1786398019',
           label: 'Star U+E003'
        },

        {
           character: '\uE004',
           image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/smile2.webp?v=1790621535',
           label: 'Smile 2 U+E004'
        },

        {
           character: '\uE005',
           image: 'https://cdn.shopify.com/s/files/1/0263/1106/5678/files/smile1.webp?v=1790621535',
           label: 'Smile 1 U+E005'
        }
      ]
    }
  };

  /* ==========================================================
     GET CURRENT PRODUCT HANDLE
     ========================================================== */

  function getCurrentProductHandle() {
    const parts = window.location.pathname
      .split('/')
      .filter(Boolean);

    const index = parts.indexOf('products');

    return index !== -1
      ? (parts[index + 1] || '')
      : '';
  }

  const currentProductHandle = getCurrentProductHandle();


  /* ==========================================================
     FIND SYMBOL SET FOR CURRENT PRODUCT
     ========================================================== */

  let SYMBOLS = null;

  Object.values(SYMBOL_GROUPS).some(function (group) {
    if (group.products.includes(currentProductHandle)) {
      SYMBOLS = group.symbols;
      return true;
    }

    return false;
  });


  /* If product isn't in any group, stop here */

  if (!SYMBOLS) {
    return;
  }


  /* ==========================================================
     COUNT VISIBLE CHARACTERS
     Better handling for emoji / multi-code-point characters
     ========================================================== */

  function getCharacterCount(value) {
    return Array.from(value || '').length;
  }


  /* ==========================================================
     UPDATE CPB INPUT
     ========================================================== */

  function updateCPBInput(input, newValue, symbol) {
    const descriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    );

    if (descriptor && descriptor.set) {
      descriptor.set.call(input, newValue);
    } else {
      input.value = newValue;
    }

    try {
      input.dispatchEvent(
        new InputEvent('input', {
          bubbles: true,
          inputType: 'insertText',
          data: symbol || null
        })
      );
    } catch (e) {
      input.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }


  /* ==========================================================
     INSERT SYMBOL INTO INPUT
     ========================================================== */

  function insertSymbol(input, symbol) {
    const currentValue = input.value || '';

    const maxLength =
      input.maxLength && input.maxLength > 0
        ? input.maxLength
        : Infinity;

    const start =
      typeof input.selectionStart === 'number'
        ? input.selectionStart
        : currentValue.length;

    const end =
      typeof input.selectionEnd === 'number'
        ? input.selectionEnd
        : currentValue.length;

    const newValue =
      currentValue.substring(0, start) +
      symbol +
      currentValue.substring(end);

    /*
      Count user-visible characters rather than raw JS string length.
    */
    const newCharacterCount = getCharacterCount(newValue);

    if (newCharacterCount > maxLength) {
      input.focus();
      return;
    }

    updateCPBInput(input, newValue, symbol);

    const cursorPosition = start + symbol.length;

    input.focus();

    try {
      input.setSelectionRange(
        cursorPosition,
        cursorPosition
      );
    } catch (e) {}
  }


  /* ==========================================================
     CREATE SYMBOL PICKER
     ========================================================== */

  function createSymbolPicker() {
    const wrapper = document.querySelector(
      '.cpb-option-type-input__wrapper-insert-characters'
    );

    if (!wrapper) {
      return false;
    }

    const input = wrapper.querySelector(
      'input[type="text"]'
    );

    if (!input) {
      return false;
    }

    /*
      Prevent duplicate picker creation.
    */
    if (wrapper.querySelector('.custom-symbol-picker')) {
      return true;
    }


    /* ========================================================
       HIDE CPB'S ORIGINAL CHARACTER BUTTON
       ======================================================== */

    const originalCharacterButton = wrapper.querySelector(
      '.cpb-option-insert-character'
    );

    if (originalCharacterButton) {
      originalCharacterButton.style.display = 'none';
    }


    /* ========================================================
       CHARACTER COUNTER
       ======================================================== */

    const counter = document.createElement('span');

    counter.className =
      'custom-symbol-character-count';

    function updateCharacterCount() {
      const currentLength =
        getCharacterCount(input.value);

      const maxLength =
        input.maxLength && input.maxLength > 0
          ? input.maxLength
          : '';

      counter.textContent = maxLength
        ? currentLength + '/' + maxLength
        : currentLength;
    }

    updateCharacterCount();

    input.addEventListener(
      'input',
      updateCharacterCount
    );

    input.addEventListener(
      'change',
      updateCharacterCount
    );


    /* ========================================================
       KEYBOARD BUTTON
       ======================================================== */

    const keyboardButton =
      document.createElement('button');

    keyboardButton.type = 'button';

    keyboardButton.className =
      'custom-symbol-keyboard-button';

    keyboardButton.textContent = '⌨';

    keyboardButton.setAttribute(
      'aria-label',
      'Choose symbol'
    );

    keyboardButton.setAttribute(
      'aria-expanded',
      'false'
    );


    /* ========================================================
       SYMBOL PICKER PANEL
       ======================================================== */

    const picker =
      document.createElement('div');

    picker.className =
      'custom-symbol-picker';

    picker.hidden = true;

    picker.setAttribute(
      'aria-label',
      'Choose a symbol'
    );


    /* ========================================================
       BUILD SYMBOL BUTTONS
       ======================================================== */

  SYMBOLS.forEach(function (symbol) {

    const button = document.createElement('button');

    button.type = 'button';

    button.className =
      'custom-symbol-button';

    /*
      Create WebP image shown to customer
    */
    const image =
      document.createElement('img');

    image.src = symbol.image;

    image.alt = symbol.label || '';

    image.className =
      'custom-symbol-image';

    image.loading = 'lazy';

    image.draggable = false;

    button.appendChild(image);

    button.setAttribute(
      'aria-label',
      'Insert ' + (symbol.label || 'symbol')
    );


    /*
      Preserve cursor position
    */
    button.addEventListener(
      'mousedown',
      function (event) {
        event.preventDefault();
      }
    );


    /*
      IMPORTANT:
      Insert the CHARACTER, not the image
    */
    button.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        insertSymbol(
          input,
          symbol.character
        );

      }
    );


    picker.appendChild(button);

  });


    /* ========================================================
       OPEN / CLOSE PICKER
       ======================================================== */

    keyboardButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();

        picker.hidden =
          !picker.hidden;

        keyboardButton.setAttribute(
          'aria-expanded',
          picker.hidden
            ? 'false'
            : 'true'
        );

        if (!picker.hidden) {
          input.focus();
        }
      }
    );


    /* ========================================================
       CLOSE WHEN CLICKING ELSEWHERE
       ======================================================== */

    document.addEventListener(
      'click',
      function (event) {

        if (
          keyboardButton.contains(event.target) ||
          picker.contains(event.target)
        ) {
          return;
        }

        picker.hidden = true;

        keyboardButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }
    );


    /* ========================================================
       ADD TO CPB
       ======================================================== */

    wrapper.appendChild(
      keyboardButton
    );

    wrapper.appendChild(
      counter
    );

    wrapper.appendChild(
      picker
    );

    return true;
  }


  /* ==========================================================
     INITIAL LOAD
     ========================================================== */

  createSymbolPicker();


  /* ==========================================================
     WATCH CPB FOR RE-RENDERS
     ========================================================== */

  const observer =
    new MutationObserver(function () {
      createSymbolPicker();
    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();